import _Image from './Image';

import './style/index.js';

export * from './type';

export const Image = _Image;

export default Image;
